import { put, call, all, takeLatest } from "redux-saga/effects";

import {
  GET_CHAT_GPT_SUMMARY, // old
  SG_GET_CHAT_GPT_SUMMARY, // old
  SG_GET_CHAT_GPT_SUMMARY_MULTI, // old
  PENDING_CHAT_GPT_SUMMARY, // old
  // GET_CHAT_GPT_SUMMARY_NODE,
  // PENDING_CHAT_GPT_SUMMARY_NODE,
  // SG_GET_CHAT_GPT_SUMMARY_NODE,
  // SG_GET_CHAT_GPT_SUMMARY_MULTI_NODE,
  SG_GET_CHAT_GPT_HISTORY_NODE,
  GET_CHAT_GPT_HISTORY_NODE,
  PENDING_CHAT_GPT_HISTORY_NODE,
  ALL_ERRORS,
} from "constants/actions";

import * as api from "constants/api";
import { GET_CHAT_GPT_SUMMARY_MULTI } from "constants/api";

function* getChatGptSummary(action) {
  yield put({ type: PENDING_CHAT_GPT_SUMMARY });
  try {
    const json = yield call(api.GET_CHAT_GPT_SUMMARY_NODE, action.payload);
    yield put({ type: GET_CHAT_GPT_SUMMARY, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e });
  }
}

export function* loadChatGptSummary() {
  yield takeLatest(SG_GET_CHAT_GPT_SUMMARY, getChatGptSummary);
}

function* getChatGptSummaryMulti(action) {
  yield put({ type: PENDING_CHAT_GPT_SUMMARY });
  try {
    const json = yield call(api.GET_CHAT_GPT_SUMMARY_MULTI_NODE, action.payload);
    yield put({ type: GET_CHAT_GPT_SUMMARY_MULTI, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e });
  }
}

export function* loadChatGptSummaryMulti() {
  yield takeLatest(SG_GET_CHAT_GPT_SUMMARY_MULTI, getChatGptSummaryMulti);
}


function* getChatGptHistory(action) {
  yield put({ type: PENDING_CHAT_GPT_HISTORY_NODE });
  try {
    // Destructure token and questionNo from payload since API expects separate params
    const { token, questionNo } = action.payload;
    const json = yield call(api.GET_CHAT_GPT_HISTORY_NODE, token, questionNo);
    yield put({ type: GET_CHAT_GPT_HISTORY_NODE, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e });
  }
}

export function* loadChatGptHistory() {
  yield takeLatest(SG_GET_CHAT_GPT_HISTORY_NODE, getChatGptHistory);
}

export default function* index() {
  yield all([
    loadChatGptSummary(),
    loadChatGptSummaryMulti(),
    loadChatGptHistory()
  ]);
}

